var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex relative z-0 overflow-hidden border-yellow border-2 rounded-bl-none rounded-lg p-1"},[_c('img',{attrs:{"src":_vm.logoImage,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }